
import i18n from '@/vueI18n'
import { mapGetters, mapActions } from 'vuex'

import AdminstrationCardNewest from './adminstration-card-newest.vue';




export default {

  data() {
    return {
      desc: { en: "Smouha Sports and Social Club is one of the oldest Egyptian clubs in Alexandria Governorate, where the club was established in 1949 and was named Smouha Club in relation to its founder Joseph Smouha, and the club’s headquarters are located in Smouha, Alexandria. The club participates in all sports and is a member of all Egyptian individual and collective games federations The club's first soccer football team rose to the Egyptian Premier League 2010/2011 season and ranked second in the 2013/2014 season, with a goal difference from the competition champion and the Egyptian Cup runner-up for the same season also participated in the African Champions League in 2015 and rose to the group stage and achieved results that Egyptian football is proud of The club also participates in handball, basketball and volleyball tournaments. Squash is the first game in the club, where world number one Mohamed El Shorbagy belongs to Smouha Club and many other stars. Smouha Club is called the Blue Wave", ar: "يعتبر نادي سموحة الرياضي الاجتماعي من أقدم الأندية المصرية بمحافظة الإسكندرية ، حيث تأسس النادي عام 1949 وأطلق عليه اسم نادي سموحة نسبة إلى مؤسسه جوزيف سموحة ، ويقع مقر النادي بمدينة سموحة بالإسكندرية. ويشارك النادي في جميع الألعاب الرياضية وهو عضو في جميع اتحادات الألعاب الفردية والجماعية المصرية ، وقد صعد أول فريق كرة قدم للنادي إلى الدوري المصري الممتاز موسم 2010/2011 واحتل المركز الثاني في موسم 2013/2014 بفارق هدف عن كما شارك بطل المسابقة وصيف كأس مصر للموسم نفسه في دوري أبطال إفريقيا عام 2015 وصعد إلى دور المجموعات وحقق نتائج تفخر بها الكرة المصرية كما يشارك النادي في بطولات كرة اليد وكرة السلة والكرة الطائرة. الاسكواش هي اللعبة الأولى في النادي حيث ينتمي المصنف الأول عالميا محمد الشوربجي إلى نادي سموحة والعديد من النجوم الآخرين. نادى سموحة يسمى بلو ويف" },
      value: [
        {
          name: {
            ar: "المهندس فرج عامر",
            en: "Eng.Farag Amer"
          },
          img: 'admin-img.png',
          email: '',
          title: {
            ar: "رئيس مجلس الإدارة",
            en: "Chairman of Board of Directors"
          }
        },
        {
          name: {
            ar: "دكتور عمر الغنيمي",
            en: "Dr.Omar ElGhonemy"
          },
          img: 'omar-elghonemy.jpg',
          email: ''
          ,
          title: {
            ar: "نائب رئيس مجلس الإدارة",
            en: "Vice Chairman of Board of Directors"
          }
        },
        {
          name: {
            ar: "أ/اشرف مختار",
            en: "Mr.Ashraf Mokhtar"
          },
          img: 'ashraf-mokhtar.jpeg',
          email: '',
          title: {
            ar: "عضو",
            en: "Member"
          }
        },
        {
          name: {
            ar: "أ/ احمد عجلان",
            en: "Mr.Ahmed Aglaan"
          },
          img: 'ahmed-aglan.jpg',
          email: '',
          title: {
            ar: "عضو",
            en: "Member"
          }
        },
        {
          name: {
            ar: "أ/ رامي فتح اللة",
            en: "Mr.Ramy Fathalla"
          },
          img: 'ramy.jpg',
          email: '',
          title: {
            ar: "عضو",
            en: "Member"
          }
        },
        {
          name: {
            ar: "د/ ماهينور سامح",
            en: "Dr.Mahinour Sameh"
          },
          img: 'mahy.jpg',
          email: '',
          title: {
            ar: "عضوة",
            en: "Member"
          }
        },
        {
          name: {
            ar: "م/ ايمان جابر",
            en: "Eng.Eman Gaber"
          },
          img: 'eman.jpeg',
          email: '',
          title: {
            ar: "عضوة",
            en: "Member"
          }
        },



      ]
    }
  },

  components: {

    AdminstrationCardNewest,

  },
  computed: {
    ...mapGetters({
      isMobile: "layout/isMobile",
      rows: 'adminstration/rows',
      loading: 'adminstration/loading',
      directors: 'adminstration/directors',
    }),
    values() {
      return this.value
    },
    language() {

      return i18n.locale == 'ar';

    },
    presidentName() {
      return this.language ? this.rows.presidentName.ar.split(" ") : this.rows.presidentName.en.split(" ")

    },
    chairman() {
      console.log('ROWS', this.rows)
      return this.rows.filter((el) => {
        return el.role.en == 'Chairman of board managers';
      })[0];
    },
    viceChairman() {
      return this.rows.filter((el) => {
        return (
          el.role.en ==
          'Vice Chairman of Board of Directors'
        );
      })[0];
    },
    boardOfDirectors() {
      return this.rows.filter((el) => {
        return (
          el.role.en == 'Member of the Board of Directors'
        );
      });
    },
  },
  methods: {
    ...mapActions({
      doFetchDefault: 'adminstration/doFetchDefault',
      doFetchDirectors: 'adminstration/doFetchDirectors',
    }),
    i18n(key, args) {
      return this.$t(key, args);
    },
  },
  async created() {
    await this.doFetchDefault();
    console.log(this.rows)
    await this.doFetchDirectors();
    console.log('this is the directors', this.directors)
  },


}

